'use client'
import Link from "next/link"
import {
    ArrowUpRight
} from "lucide-react"

import { Button } from "@/components/ui/button"
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "@/components/ui/card"
import { Label } from "./ui/label"
import { Input } from "./ui/input"

export default function TransactionForm({ transaction, setOpen }: { transaction: any, setOpen: (open: boolean) => void }) {

    return (
        <>
            <div className="grid gap-4 py-4">
                <div className="grid grid-cols-4 items-center gap-4">
                    <Label htmlFor="name" className="text-right">
                        Name
                    </Label>
                    <Input
                        id="name"
                        defaultValue={transaction.name}
                        className="col-span-3"
                    />
                </div>
                <div className="grid grid-cols-4 items-center gap-4">
                    <Label htmlFor="username" className="text-right">
                        Email
                    </Label>
                    <Input
                        id="username"
                        defaultValue={transaction.email}
                        className="col-span-3"
                    />
                </div>
                <div className="grid grid-cols-4 items-center gap-4">
                    <Label htmlFor="username" className="text-right">
                        Amount
                    </Label>
                    <Input
                        id="username"
                        defaultValue={transaction.totalSales?.amount}
                        className="col-span-3"
                    />
                </div>
            </div>
            <div>
                <Button size="sm" onClick={() => {

                    setOpen(false)
                }}>
                    Save
                </Button>
            </div>
        </>
    )
}